<ycn-chart-zoom-controls
    [hidden]="_hideZoomControls"
    [mouseOverChart]="mouseOverChart">
    @if (showAnnotationsToggle()) {
        <div class="chart-zoom-controls-item">
            <button type="button" class="btn"
                [class.btn-primary]="annotationsHidden"
                [class.btn-secondary]="!annotationsHidden"
                [attr.aria-label]="annotationsHidden ? 'Show Annotations' : 'Hide Annotations'"
                [attr.aria-pressed]="annotationsHidden"
                ycnTooltip
                [tooltipTitle]="annotationsHidden ? 'Show Annotations' : 'Hide Annotations'"
                tooltipPlacement="bottom"
                (click)="annotationsHiddenChange.emit(!annotationsHidden)">
                    <svg ycnIcon name="icon-password-no-show"></svg>
            </button>
        </div>
    }
</ycn-chart-zoom-controls>
<div #chart [id]="chartLocalId"
    [class]="chartClasses"
    [style]="chartStyles"
    (mouseup)="handleClickOrDrag($event)"
    (mousedown)="setMouseDownCoords($event)"
    (mouseenter)="mouseOverChart = true"
    (mouseleave)="mouseOverChart = false">
</div>
